import React from "react";

import
{
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import
{
    faArrowTrendUp,
    faArrowTrendDown,
    faMinus
}
from "@fortawesome/free-solid-svg-icons";

export default function InsightKpiCard(
{
    title,

    value,

    suffix = "",

    percentageChange = 0,

    comparisonText = "MoM",

    positiveIsGood = true
})
{
    const positive =
        percentageChange > 0;

    const negative =
        percentageChange < 0;

    const neutral =
        percentageChange === 0;

    const good =
        neutral
            ? true
            : positive
                ? positiveIsGood
                : !positiveIsGood;

    const indicatorColour =
        neutral
            ? "#9098A4"
            : good
                ? "#2ECC71"
                : "#E74C3C";

    const indicatorBackground =
        neutral
            ? "rgba(144,152,164,.15)"
            : good
                ? "rgba(46,204,113,.14)"
                : "rgba(231,76,60,.14)";

    const indicatorIcon =
        neutral
            ? faMinus
            : positive
                ? faArrowTrendUp
                : faArrowTrendDown;

    const container =
    {
        display: "flex",

        flexDirection: "column",

        justifyContent: "space-between",

        width: "100%",

        height: "85px",
		
		boxSizing: "border-box", 

        padding: "12px",

        background:
            "linear-gradient(180deg,#2B2E35 0%,#17191D 100%)",

        border:
            "1px solid rgba(255,255,255,.08)",

        borderRadius: "6px",

        boxShadow:
            "0 12px 32px rgba(0,0,0,.28)"
    };

    const titleStyle =
    {
        color: "#C8CDD5",

        fontSize: "12px",

        fontWeight: 500,

        textTransform: "uppercase",

        letterSpacing: "1.4px"
    };

    const valueStyle =
    {
        display: "flex",

        justifyContent: "center",

        alignItems: "center",

        flexGrow: 1,

        color: "white",

        fontSize: "21px",

        fontWeight: 500,
		minHeight:'30px'
		
    };

    const footer =
    {
        display: "flex",

        alignItems: "center",

        gap: "10px"
    };

    const indicator =
    {
        display: "flex",

        alignItems: "center",

        gap: "6px",

        padding: "4px 10px",

        borderRadius: "999px",

        background: indicatorBackground,

        color: indicatorColour,

        fontSize: "12px",

        fontWeight: 700
    };

    const comparison =
    {
        color: "#AAB3BE",

        fontSize: "12px",

        fontWeight: 500
    };

    return (

        <div style={container}>

            <div style={titleStyle}>
                {title}
            </div>

            <div style={valueStyle}>
                {value}{suffix}
            </div>

            <div style={footer}>

                <div style={indicator}>

                    <FontAwesomeIcon
                        icon={indicatorIcon}
                    />

                    {Math.abs(percentageChange).toFixed(1)}%

                </div>

                <div style={comparison}>
                    {comparisonText}
                </div>

            </div>

        </div>

    );
}